import Validator from '@/shared/utils/validator'

async function triggerAction(dataKey, data, networkRepo, method = 'post') {
  Validator.require('dataKey', dataKey, 'string')

  const response = await networkRepo.triggerAction(dataKey, data, method)

  Validator.requireObject('processorResponse', response)
  Validator.require('response.statusCode', response.statusCode, 'number')
  return response
}

export default triggerAction
